import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/who-we-are.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function WhoWeAre() {
  return (
    <div className="ne-page">
      <SEO
        title="Who We Are"
        description="CIRCODU is a non-profit research and consultancy organization founded in 2007, dedicated to driving sustainable development through rigorous research and impactful projects across Uganda and Africa."
        keywords="CIRCODU, who we are, about us, non-profit organization, research and consultancy, sustainable development, Uganda, Africa, community development, energy research, environmental conservation, public health research, agricultural development, water and sanitation research, CIRCODU mission and vision"
        url="/about-us/who-we-are"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Who We Are</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">About Us</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Who We Are</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              <p className="texthome1">
                Founded in 2007, the Centre for Integrated Research and
                Community Development Uganda (CIRCODU) is a non-profit
                organization driven by a single, powerful conviction that
                rigorous research and smart consultancy can change lives. From
                the villages of Uganda to communities across Kenya, Tanzania,
                Gambia, Mali, Sudan, and beyond, we show up where it matters
                most, armed with data, expertise, and an unwavering commitment
                to a better world.
              </p>
              <p className="texthome1">
                We are researchers, analysts, and community champions. Our work
                sits at the intersection of science and society tackling the
                challenges that affect people's health, environment, and
                livelihoods every day. We don't just study problems. We help
                solve them. Whether it's testing cookstoves for safety and
                efficiency, building local capacity, or providing consultancy
                services, we are on the ground, making a difference.
              </p>
              <p className="texthome1">
                At the core of everything we do is a research-based approach
                that ensures every recommendation, every project, and every
                intervention is grounded in evidence and built for real-world
                impact. CIRCODU delivers world-class research implementation and
                consultancy services across five critical sectors:
              </p>
              <ul className="texthome1">
                <li className="mt-1">
                  🌿 <b>Energy</b> — Promoting sustainable energy use and
                  leading the way in energy project monitoring and evaluation
                </li>
                <li className="mt-1">
                  ♻️ <b>Waste Management</b> — Building cleaner, more
                  sustainable communities
                </li>
                <li className="mt-1">
                  🌾 <b>Agricultural Management</b> — Supporting agricultural
                  development, food security and rural development
                </li>
                <li className="mt-1">
                  💧 <b>Water and Sanitation</b> — Ensuring access to clean
                  water and dignified living
                </li>
                <li className="mt-1">
                  🏥 <b>Public Health</b> — Raising health awareness and driving
                  better outcomes for communities
                </li>
              </ul>
              <p className="texthome1">
                We are more than just a research center. We are a catalyst for
                change, a partner in progress, and a champion for communities.
                What started in Uganda has grown into a continent-wide mission.
                We are proud to have led impactful studies and projects across
                Africa, bringing the same dedication to excellence whether we
                are working locally or across borders. With CIRCODU, it's not
                just about what we do; it's about who we are and the impact we
                create together.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WhoWeAre;
